import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import PageContext from '@contexts/pageContext'

import CreateProviderModal from '@modals/CreateProviderModal'

import PageContent from './components/PageContent'

export const defaultPageFilters = {}

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreateProviderModal: {
      closeModal: () => setState({ showCreateProviderModal: false }),
      createProvider: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateProviderModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateProviderModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateProviderModal: () => setState({ showCreateProviderModal: true }),
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateProviderModal
          callbacks={callbacks('CreateProviderModal', setState)}
          showModal={showCreateProviderModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
